import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeLanguage } from '../actions/uiActions';

class LandingPage extends Component {
  componentDidMount() {
    const { location , changeLanguage } = this.props;
    const { query } = location;
    (query.lang !== undefined) ? changeLanguage(query.lang) : null ;
  }
  render() {
    const { children } = this.props;
    return (
      <div>{children}</div>
    );
  }
}

function mapStateToProps(state) {
  return {
    mixpanel : state.ui.tempData.mixpanel
  }
}

const mapDispatchToProps = (dispatch)=>bindActionCreators({ changeLanguage },dispatch)

export default connect(mapStateToProps,mapDispatchToProps)(LandingPage)



/** WEBPACK FOOTER **
 ** ./src/containers/landingPage.js
 **/